/// <amd-module name="VSS/Features/Services/AccountMappingService" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export function queueSyncUserAccountMapping(pageContext: IVssPageContext): Promise<any> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<any>("ms.vss-features.sync-user-account-mapping-data-provider", {
        queueSyncUserAccountMapping: true,
    }).then(result => { return result; });
}

export function activateMapping(pageContext: IVssPageContext, subjectDescriptor: string, accountId: string): Promise<any> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<any>("ms.vss-features.sync-user-account-mapping-data-provider", {
        activateMapping: true,
        subjectDescriptor,
        accountId
    }).then(result => { return result; });
}